import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_SECRET_KEY;

export const encryptAndStore = (key, value) => {
  try {
    const encryptedValue = CryptoJS.AES.encrypt(value, secretKey).toString();

    localStorage.setItem(key, encryptedValue);
    console.log("Data encrypted and stored successfully.");
  } catch (error) {
    console.error("Error encrypting data:", error);
  }
};

export const decryptAndRetrieve = (key) => {
  try {
    const encryptedValue = localStorage.getItem(key);

    if (!encryptedValue) {
      console.log("No data found for the given key.");
      return null;
    }

    const bytes = CryptoJS.AES.decrypt(encryptedValue, secretKey);
    const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);

    return decryptedValue;
  } catch (error) {
    console.error("Error decrypting data:", error);
    return null;
  }
};

export const removeFromStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing data from LocalStorage:", error);
  }
};
